export class UnprocessableEntityError extends Error {
    constructor() {
        super("Bad Request!");
    }
}
